import EldExportList from "../eld-export/EldExportList";
import { ImportExport } from "@material-ui/icons";

export default {
  icon: ImportExport,
  list: EldExportList,
};
